import styled from "@emotion/styled";
import { fontAngkor, fontFredoka } from "@product/scmp-sdk";

export const Container = styled.div``;

export const LandingVideoContainer = styled.div``;

export const MainHeading = styled.div`
  padding-block: 28px;

  color: #0f75bf;
  font-weight: 400;
  font-size: 36px;
  font-family: ${fontAngkor};
  line-height: 40px;
  letter-spacing: -0.72px;
  text-align: center;
  ${props => props.theme.breakpoints.up("tablet")} {
    padding-block: 64px;

    font-size: 48px;
    line-height: 56px;
    letter-spacing: -0.96px;
  }
`;

export const MoreVideosContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;

  margin-block: 32px;
  margin-inline: 11px;

  ${props => props.theme.breakpoints.up("desktop")} {
    row-gap: 40px;

    margin-block: 64px;
    padding-block: 0 56px;
  }
`;

export const MoreVideosCardsAndLoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MoreVideosCardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  justify-content: center;

  ${props => props.theme.breakpoints.up("desktop")} {
    display: grid;
    grid-template-columns: repeat(3, min-content);
    gap: 32px 20px;

    padding-inline: 40px;
  }

  ${props => props.theme.breakpoints.up("largeDesktop")} {
    display: grid;
    grid-template-columns: repeat(4, min-content);
  }
`;

export const MoreVideosTitle = styled.div`
  inline-size: fit-content;
  margin: auto;

  color: #0f75bf;
  font-weight: 400;
  font-size: 28px;
  font-family: ${fontAngkor};
  line-height: 32px;
  letter-spacing: -0.84px;
  text-align: center;
  text-transform: uppercase;

  ${props => props.theme.breakpoints.up("desktop")} {
    padding: 10px;

    font-size: 40px;
    line-height: 54px;
    letter-spacing: -1.2px;
  }
`;

export const LoadingText = styled.div`
  color: #999999;
  font-weight: 600;
  font-size: 24px;
  font-family: ${fontFredoka};
  line-height: 38px;
  letter-spacing: 0.72px;
  text-align: center;
  text-transform: uppercase;
`;
